<div *ngIf="isTriangle" class="triangle"></div>
<ul [class.up]='dropdownUp'>
	<ng-container *ngFor="let tab of tabs; let i = index">
		<li
			*ngIf="!permissions[i] || (permissions[i] | async)"
			(click)="emit(changeTabValue ? tab[1] : tab[0])"
			>{{ changeTabValue ? tab[0] : tab[1] }}
		</li>
	</ng-container>
</ul>
